var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"side-panel-content filters"},[(_vm.villagesDB)?_c('FilterSelect',{attrs:{"title":'Villages',"name":'villageSelection',"options":_vm.villagesKeyList,"defaultValue":'Select Village',"multiple":true,"label":'properties.key'},on:{"villageSelection":function (selection) {
      _vm.filters.villageSelection = selection;
    }}}):_vm._e(),_c('FilterSelect',{attrs:{"title":'Projects',"name":'projectSelection',"defaultValue":'Select Project',"options":[
      { value: 'all', name: 'All Villages'},
      { value: 'SLS2', name: 'SLS2'},
      { value: 'DRR4', name: 'DRR4'} ]},on:{"projectSelection":function (selection) {
      _vm.filters.projectSelection = selection;
    }}}),_c('FilterSelect',{attrs:{"title":'Districts',"name":'districtSelection',"defaultValue":'Select District',"options":[
      { value: 'all', name: 'All Districts'},
      { value: 'Phaxay', name: 'Phaxay'},
      { value: 'Kham', name: 'Kham'},
      { value: 'Houameang', name: 'Huameuang'},
      { value: 'Nonghet', name: 'Nonghed'}
    ]},on:{"districtSelection":function (selection) {
      _vm.filters.districtSelection = selection;
    }}}),_c('FilterSelect',{attrs:{"title":'Activities',"name":'activitySelection',"defaultValue":'Select Activity',"options":[
      { value: 'all', name: 'All Villages'},
      { value: 'baseline', name: 'Baseline Strategy'},
      { value: 'with_infra', name: 'Infra. All'},
      { value: 'infra_bridge', name: 'Infra. Bridge'},
      { value: 'infra_box_culvert', name: 'Infra. Box Culvert'},
      { value: 'infra_wire_constuction', name: 'Infra. Irrigation'},
      { value: 'infra_road', name: 'Infra. Road'} ]},on:{"activitySelection":function (selection) {
      _vm.filters.activitySelection = selection;
    }}}),_c('Toggle',{attrs:{"title":'Names',"name":'displayVillageName',"defaultValue":false},on:{"displayVillageName":function (status) {
      _vm.filters.displayVillageName = status;
    }}}),_c('Toggle',{attrs:{"title":'Areas',"name":'displayVillageArea',"defaultValue":false},on:{"displayVillageArea":function (status) {
      _vm.filters.displayVillageArea = status;
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }